import React, { useState } from 'react'

interface IInputBox {
  title: string
  maxWidth?: number
  value: string
  onChange: (value: string) => void
  suffix?: string
  style?: React.CSSProperties
}

const formatter = new Intl.NumberFormat('da-DK')
export const formatValue = (value: string | undefined) => {
  if (value === undefined) return undefined
  const digitsOnly = value.replace(/(?!^-)[^\d]/g, '').trim()
  if (digitsOnly === '') return ''
  if (digitsOnly === '-') return '-'
  const num = Number(digitsOnly)
  return formatter.format(num)
}

export default function InputBox({ title, maxWidth, value, onChange, suffix, style }: IInputBox) {
  suffix ??= 'kr'
  const boxContainer: React.CSSProperties = {
    borderColor: 'black',
    borderWidth: 0,
    borderStyle: 'solid',
    flex: 1,
    whiteSpace: 'pre-line',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    //gap: 6,
    maxWidth,
    ...style,
  }

  const boxInner: React.CSSProperties = {
    borderColor: 'black',
    borderWidth: 0,
    borderStyle: 'solid',
    flex: 1,
    whiteSpace: 'pre-line',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    maxWidth,
  }

  const labelStyle: React.CSSProperties = {
    fontSize: 16,
    color: '#333',
    fontWeight: 500,
    marginBottom: 4,
  }

  const inputStyle: React.CSSProperties = {
    borderRadius: 12,
    border: '2px solid #ccc',
    padding: '5px 8px',
    fontSize: 18,
    color: '#222',
    outline: 'none',
    transition: 'all 0.2s ease',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    textAlign: 'right',
  }

  const inputFocusStyle: React.CSSProperties = {
    ...inputStyle,
    border: '2px solid #3B82F6', // blå nuance
    boxShadow: '0 0 0 3px rgba(59,130,246,0.25)',
  }

  const [focused, setFocused] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.trim()

    // fjern alt undtagen tal og ét minus-tegn i starten
    const cleaned = raw.replace(/(?!^-)[^\d]/g, '')

    if (cleaned === '' || cleaned === '-') {
      onChange(cleaned)
      return
    }

    const num = Number(cleaned)
    const formatted = formatter.format(num)
    onChange(formatted)
  }

  return (
    <div style={boxContainer}>
      <div style={boxInner}>
        <label style={labelStyle}>{title}</label>
      </div>
      <div style={boxInner}>
        <input
          type="text"
          value={formatValue(value ?? '')}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={handleChange}
          // placeholder="Indtast v"
          style={focused ? inputFocusStyle : inputStyle}
        />
        {/* {suffix ? <span style={suffixStyle}>{suffix}</span> : null} */}
      </div>
    </div>
  )
}

const suffixStyle: React.CSSProperties = {
  position: 'absolute',
  right: 29,
  bottom: 22,
  //bottom: 5,
  //bottom: '9.5%',
  //top: '50%',
  //transform: 'translateY(-50%)',
  color: '#555',
  fontSize: 16,
  pointerEvents: 'none',
}
